<template>
    <div class="acomodar">
        
    </div>
</template>

<script>
export default {
    name: 'BYInicio',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 9px;
  margin-bottom: 8px;
  padding-bottom: 5%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 0.25%;
  margin-right: 10px;
  height: 100vh;
  border-radius: 10px 10px 10px 10px;
  overflow-x: auto;
  overflow-y: none;
}
</style>